import {LineupPlayers as CFBClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/cfb/classic';
import {LineupPlayers as CFBSingleGameLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/cfb/single-game';
import {LineupPlayers as MLBClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mlb/classic';
import {LineupPlayers as MLBSingleGameLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mlb/single-game';
import {LineupPlayers as NFLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/classic';
import {LineupPlayers as NFLSingleGameLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nfl/single-game';
import {LineupPlayers as NHLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nhl/classic';
import {LineupPlayers as NHLShowDownLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/nhl/showdown';
import {LineupPlayers as MMAClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/mma/showdown';
import {LineupPlayers as GOLFClassicLineupPlayers} from './golf/classic';
import {LineupPlayers as NASCARClassicLineupPlayers} from './nascar/classic';
import {LineupPlayers as NBAClassicLineupPlayers} from './nba/classic';
import {LineupPlayers as NBASingleGameLineupPlayers} from './nba/single-game';
import {LineupPlayers as LOLClassicLineupPlayers} from 'components/organisms/lineup/components/desktop/lineup-players/sports/lol/classic';

const Factory = {
    getComponent(sportConfig) {
        if (sportConfig.isSportNba()) {
            if (sportConfig.isGameTypeClassic()) {
                return NBAClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return NBASingleGameLineupPlayers;
            }
        } else if (sportConfig.isSportNhl()) {
            if (sportConfig.isGameTypeClassic()) {
                return NHLClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return NHLShowDownLineupPlayers;
            }
        } else if (sportConfig.isSportCfb()) {
            if (sportConfig.isGameTypeClassic()) {
                return CFBClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return CFBSingleGameLineupPlayers;
            }
        } else if (sportConfig.isSportMlb()) {
            if (sportConfig.isGameTypeClassic()) {
                return MLBClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return MLBSingleGameLineupPlayers;
            }
        } else if (sportConfig.isSportNfl()) {
            if (sportConfig.isGameTypeClassic()) {
                return NFLClassicLineupPlayers;
            } else if (sportConfig.isGameTypeSingleGame()) {
                return NFLSingleGameLineupPlayers;
            }
        } else if (sportConfig.isSportGolf()) {
            return GOLFClassicLineupPlayers;
        } else if (sportConfig.isSportNascar()) {
            return NASCARClassicLineupPlayers;
        } else if (sportConfig.isSportMma()) {
            return MMAClassicLineupPlayers;
        } else if (sportConfig.isSportLol()) {
            return LOLClassicLineupPlayers;
        }

        throw new Error(`Factory ERR: unknown sport ${sportConfig.getSport()}`);
    },
};

export {Factory};
